import { forwardRef } from 'react';
import { InputFieldBar } from './input-field-bar';
import { InputFieldWrapper } from './input-field-wrapper';
import { inputFieldStyles } from './input-field.style';
import clsx from 'clsx';

type InputFieldProps = {
	label: string;
	icon?: React.ReactNode;
	hint?: string;
	children?: React.ReactNode;
	isSuccess?: boolean;
	isError?: boolean;
} & React.ComponentPropsWithRef<'input'>

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(({
	label,
	icon,
	hint,
	children,
	isSuccess,
	isError,
	...otherProps
}, ref) => {
	return (
		<InputFieldWrapper
			id={otherProps.id}
			required={otherProps.required}
			label={label}
			hint={hint}
			isSuccess={isSuccess}
			isError={isError}
		>
			<InputFieldBar
				className={clsx('group', inputFieldStyles.inputField)}
				icon={icon}
				isSuccess={isSuccess}
				isError={isError}
				ref={ref}
				{...otherProps}
			>
				{children}
			</InputFieldBar>
		</InputFieldWrapper>
	);
});

InputField.displayName = 'InputField';